import { FormLabel } from "react-bootstrap";
import Select from "react-select";
export const SelectField = ({ label, name, options, onChange, searchable }) => {
  return (
    <div className="form-group">
      <FormLabel>{label}</FormLabel>
      <Select
        name={name}
        options={options}
        onChange={onChange}
        isSearchable={searchable || true}
        placeholder="Select"
      />
    </div>
  );
};

export const CheckBox = ({ label, onChange, ...rest }) => {
  return (
    <div class="form-check form-switch">
      <input
        class="form-check-input"
        type="checkbox"
        id="flexSwitchCheckChecked"
        onChange={(e) => e.target.checked}
        {...rest}
      />
      {label && (
        <label class="form-check-label" for="flexSwitchCheckChecked">
          {label}
        </label>
      )}
    </div>
  );
};
